import React from 'react'
import { Button } from '@mui/material';
import {useNavigate} from 'react-router-dom'
import { useFormContext } from 'react-hook-form';


const ExitButtonSolicitudViolencia = () => {
  const navigate = useNavigate();
  const { reset } = useFormContext();

  return (
      <Button 
        type='button' 
        className="exit-button fixed bottom-9 right-9 " 
        sx={{position: "fixed", width: "65px", height: "65px"}} 
        onClick={() => {
          reset()
          navigate(-1)
          }}>
        <div>
          <p className='m-0 text-x1 font-bold'>X</p>
          <p className='m-0'>Salir</p>
        </div>
      </Button>
  )
}

export {ExitButtonSolicitudViolencia}